<script setup lang='ts'>
    import { requireIsAdministrator as vRequireIsAdministrator } from '@/shared/directives/requirePermission';
    import { onMounted, ref, Ref, watch } from 'vue';
    import { RouteLocation, Router, useRoute, useRouter } from 'vue-router';

    const router: Router = useRouter();
    const route: RouteLocation = useRoute();
    const selectedTab: Ref<string | undefined> = ref(undefined);

    onMounted(() => {
        selectedTab.value = route.name?.toString();

        watch(selectedTab, () => {
            if (selectedTab.value === undefined) {
                return;
            }

            router.push(selectedTab.value);
        });
    });
</script>

<template>
    <section v-require-is-administrator>
        <header>
            <h1 class="title">
                Access Policy
            </h1>
        </header>
        <div class="mt-2">
            <slot name="controls" />
        </div>
        <hr>
        <section>
            <b-tabs
                v-model="selectedTab"
                type="is-boxed">
                <b-tab-item
                    value="LibraryPolicy"
                    label="Library Policy">
                    <template #header>
                        Library policies
                    </template>
                    <slot
                        name="librarypolicy" />
                </b-tab-item>
                <b-tab-item
                    value="UserAttributes"
                    label="User Attributes">
                    <template #header>
                        User roles
                    </template>
                    <slot
                        name="userattributes" />
                </b-tab-item>
                <b-tab-item
                    value="ApplicationAttributes"
                    label="Application Attributes">
                    <template #header>
                        Application access
                    </template>
                    <slot
                        name="applicationattributes" />
                </b-tab-item>
                <b-tab-item
                    value="System"
                    label="Systems & Roles">
                    <template #header>
                        System & role definitions
                    </template>
                    <slot
                        name="systemandroles" />
                </b-tab-item>
            </b-tabs>
        </section>
        <section>
            <slot
                name="modal" />
        </section>
    </section>
</template>

<style scoped>

</style>
